import Swiper, {Autoplay, Navigation, Pagination} from "swiper";
Swiper.use([Navigation,Pagination, Autoplay])

export const slideshow = () => {
    new Swiper('.slideshow', {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".slideshow .swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: ".slideshow .swiper-button-next",
            prevEl: ".slideshow .swiper-button-prev",
        },
    })
    new Swiper('.product_slider', {
        // autoplay: {
        //     delay: 3500,
        //     disableOnInteraction: false,
        // },
        loop: true,
        navigation: {
            nextEl: ".product_slider .swiper-button-next",
            prevEl: ".product_slider .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.product_bestseller', {
        // autoplay: {
        //     delay: 3500,
        // },
        loop: true,
        navigation: {
            nextEl: ".product_bestseller .swiper-button-next",
            prevEl: ".product_bestseller .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.product_viewed', {
        // autoplay: {
        //     delay: 3500,
        // },
        loop: true,
        navigation: {
            nextEl: ".product_viewed .swiper-button-next",
            prevEl: ".product_viewed .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.carousel', {
        autoplay: {
            delay: 2500,
        },
        loop: true,
        navigation: {
            nextEl: ".carousel .swiper-button-next",
            prevEl: ".carousel .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.reviews', {
        slidesPerView: 1,
        spaceBetween: 40,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        loop: true,
        pagination: {
            el: ".reviews .swiper-pagination",
            clickable: true,
        }
    })
}